import React from 'react';
import PreferredDateField from './PreferredDateField';
import { useInquiryDate } from '../../utils/inquiryDate';

/** Public-site picker: remembers the choice and adds it to every enquiry message. */
const InquiryDatePicker = ({ className = '' }: { className?: string }) => {
  const [date, setDate] = useInquiryDate(true);
  return (
    <PreferredDateField
      className={`inquiry-date-picker ${className}`.trim()}
      value={date}
      onChange={setDate}
      label="When would you like your shoot?"
      dateLabel="I have a date in mind"
      laterLabel="I'll decide later"
    />
  );
};

export default InquiryDatePicker;
